import React from 'react';
import { ColorPicker, Flex, Typography, Switch, Divider } from 'antd';

const ChartOptions = ({ widget }) => {
  const { chartConfig, setChartConfig, changeAreaChartDesign } = widget;

  const handleChangeX = (checked) => {
    setChartConfig({ ...chartConfig, showXAxis: checked });
  };

  const handleChangeY = (checked) => {
    setChartConfig({ ...chartConfig, showYAxis: checked });
  };

  const handleAreaColor = (key, color) => {
    setChartConfig((prev) => ({
      ...prev,
      areaConfig: {
        ...prev.areaConfig,
        [key]: color,
      },
    }));
  };

  if (!chartConfig?.load_chart) return null;

  return (
    <div className='grid gap-2 '>
      <Flex align='center' gap='small'>
        <Switch checked={chartConfig.showXAxis} onChange={handleChangeX} size='small' />
        <Typography className='font-medium text-sm'>Show X-Axis Labels</Typography>
      </Flex>

      <Flex align='center' gap='small'>
        <Switch checked={chartConfig.showYAxis} onChange={handleChangeY} size='small' />
        <Typography className='font-medium text-sm'>Show Y-Axis Labels</Typography>
      </Flex>

      {changeAreaChartDesign && (
        <>
          <Divider />
          <div className='grid gap-3'>
            <Flex align='center' gap='small'>
              <ColorPicker
                size='small'
                value={chartConfig?.areaConfig?.strokeColor || '#536A8B'}
                onChange={(color) => handleAreaColor('strokeColor', color.toHexString())}
              />
              <Typography className='font-medium text-sm'>Stroke Color</Typography>
            </Flex>
            <Flex align='center' gap='small'>
              <ColorPicker
                size='small'
                value={chartConfig?.areaConfig?.fillColor || '#F0F6FF'}
                onChange={(color) => handleAreaColor('fillColor', color.toHexString())}
              />
              <Typography className='font-medium text-sm'>Fill Color</Typography>
            </Flex>
          </div>
        </>
      )}
    </div>
  );
};

export default ChartOptions;
